import styled from 'styled-components'

import media from 'utils/media'

export const StyledNextArticle = styled.div`
   text-align: center;
   display: flex;
   align-items: center;
   justify-content: center;
   white-space: nowrap;
   margin: 24px 0px;
   font-family: 'Portrait';
   font-size: 18px;
   line-height: 29px;
   font-weight: 500;

   &::before,
   &::after {
      width: 100%;
      height: 1px;
      background-color: ${({ theme }) => theme.colors.grey_2};
      display: block;
      content: '';
   }

   &::before {
      margin-right: 16px;
   }

   &::after {
      margin-left: 16px;
   }
`

export const StyledArticle = styled.article`
   width: 100%;
   padding: 24px 24px 48px;

   ${media.greaterThan('sm')`
      max-width: 540px;
      margin: 0 auto;
      padding: 24px 16px 48px;
   `};

   ${media.greaterThan('md')`
      max-width: calc(100% - 120px);
      padding: 60px 0;
   `};

   ${media.greaterThan('lg')`
      max-width: 800px;
      padding: 70px 0;
   `};
`

export const PDFWrapper = styled.div`
   margin: 40px 0;

   a {
      svg {
         margin-left: 22px;
         margin-right: 0;
      }
   }
`

export const StyledContent = styled.div`
   margin-top: 24px;

   ${media.greaterThan('md')`
      margin-top: 48px;
   `};

   & > div {
      & > * {
         margin-bottom: 40px;
      }

      & > p {
         font-size: 16px;
         line-height: 180%;
         ${media.greaterThan('md')`
            font-size: 18px;
            line-height: 30px;
         `};
         letter-spacing: 1%;
         font-weight: 300;

         & > img {
            margin-top: 1.75rem;
            margin-bottom: 1.75rem;
            width: 100%;
         }

         &:last-of-type {
            margin-bottom: 0;
         }
      }

      & > h2,
      & > h3 {
         font-weight: 700;
         margin-bottom: 12px;
      }

      & > h2 {
         font-size: 24px;
         line-height: 38px;
         font-weight: 500;
      }

      & > h3 {
         font-size: 20px;
         line-height: 26px;
         font-weight: 500;
      }

      a {
         color: ${({ theme }) => theme.colors.hotCinnamon};
         display: inline;
         position: relative;

         &::before {
            content: '';
            width: 100%;
            height: 1px;
            background: ${({ theme }) => theme.colors.hotCinnamon};
            position: absolute;
            bottom: 2px;
            opacity: 0;
            transition: ${({ theme }) => theme.transitions.main};
         }

         &:hover {
            &::before {
               opacity: 1;
            }
         }
      }

      & > ol {
         counter-reset: item;
         list-style-type: none;
         margin-left: 0;
         font-size: 16px;
         line-height: 180%;
         ${media.greaterThan('md')`
            font-size: 18px;
            line-height: 30px;
         `};
         letter-spacing: 1%;
         font-weight: 300;

         li {
            counter-increment: item;
            position: relative;
            padding-left: 36px;

            &:before {
               content: counter(item, decimal-leading-zero);
               position: absolute;
               left: 0;
               top: 0;
               color: ${({ theme }) => theme.colors.header};
               font-weight: 500;
               font-size: 32px;
               line-height: 1;
               transform: translateY(-2px);
               letter-spacing: 1%;
               font-family: 'Portrait';
            }
         }
      }

      & > ul li {
         font-size: 16px;
         line-height: 180%;
         ${media.greaterThan('md')`
            font-size: 18px;
            line-height: 30px;
         `};
         letter-spacing: 1%;
         font-weight: 300;
         position: relative;
         list-style-type: disc;
         padding-left: 0;
         transform: translateX(20px);
      }
   }
`

export const StyledNextPost = styled.div`
   margin: 48px 0;

   a {
      text-decoration: underline;

      &:hover {
         color: ${({ theme }) => theme.colors.hotCinnamon};
      }
   }
`

export const StyledDivider = styled.div`
   height: 0.5px;
   width: 100%;
   background-color: ${({ theme }) => theme.colors.grey_2};
   margin-top: 40px;
`

export const StyledSubscribeButtonWrapper = styled.div`
   color: ${({ theme }) => theme.colors.hotCinnamon};
   background-color: ${({ theme }) => theme.darkMode ? theme.colors.btnDarkBg : theme.colors.white};
   padding: 8px;
   position: fixed;
   bottom: 24px;
   left: 50px;
   border-radius: 12px;
   display: none;

   ${media.greaterThan('md')`
      display: block;
   `};
`

export const StyledSubscribeButton = styled.button`
   background-color: ${({ theme }) => theme.colors.hotCinnamon};
   color: ${({ theme }) => theme.colors.white};
   border: none;
   border-radius: 6px;
   padding: 9px 12px;
   cursor: pointer;
   font-family: 'Portrait';
   font-size: 16px;
   line-height: 19px;
   height: 40px;
   display: flex;
   align-items: center;
   justify-content: center;
   width: 108px;
   z-index: 10000;
`

export const StyledSocialsWrapper = styled.div`
   display: flex;
   align-items: center;
   gap: 9px;
   justify-content: center;
   margin-bottom: 0px;

   ${media.greaterThan('md')`
      justify-content: flex-start;
      margin-bottom: 0;
   `};
`

export const StyledNewsletterFormContainer = styled.div`
   max-width: 320px;
   margin: 40px auto 40px;
   display: flex;
   flex-direction: column;
   align-items: center;
   width: 100%;

   & > div {
      width: 100%;
      flex-grow: 1;
   }
`

export const StyledNewsletterFormTitle = styled.div`
   font-size: 36px;
   line-height: 36px;
   font-weight: 450;
   font-family: 'Portrait';
   text-align: center;
   color: ${({ theme }) => (theme.darkMode ? theme.colors.white : theme.colors.accent)};
   margin-bottom: 16px;
`

export const StyledEmblem = styled.img`
   margin: auto;
   margin-bottom: 16px;

   ${({ theme }) =>
      theme.darkMode &&
      `
      filter: invert(1) grayscale(1) brightness(2);
   `}
`
